import { Container } from "../../components/Container";

export function Smallform() {
  
  return (
    <section
      id="free-chapters"
      aria-label="Free preview"
      className="scroll-mt-14 bg-blue-50 sm:scroll-mt-32 p-4"
    >
      <div className="overflow-hidden lg:relative">
        <Container
          size="md"
          className="relative grid grid-cols-1 lg:grid-cols-2 gap-y-12 lg:static items-center py-20"
        >
          {/* <Pattern className="absolute -top-32 left-0 w-full sm:-top-5 sm:left-3/4 sm:ml-8 sm:w-auto md:left-2/3 lg:left-auto lg:right-2 lg:ml-0 xl:left-2/3 xl:right-auto" /> */}
          <div >
            <h2 className="font-display text-3xl lg:text-6xl font-extrabold tracking-tight text-black sm:w-3/4 sm:text-6xl md:w-2/3 lg:w-auto" data-aos="fade-up">
              Subscribe to our mailing list
            </h2>
            <p className="mt-4 text-lg tracking-tight text-gray-500" data-aos="fade-up" >
              Stay informed with the latest medical updates by connecting with us and accessing the most up-to-date information.
            </p>
          </div>
          <form className="lg:pl-16" data-aos="fade-up" >
            <h3 className="text-base font-medium tracking-tight text-gray-500" data-aos="fade-up" >
              Enter your E-mail address{" "}
              <span aria-hidden="true">&rarr;</span>
            </h3>
            <div className="mt-4 sm:relative sm:flex sm:items-center sm:py-0.5 sm:pr-2.5">
              <div className="relative sm:static sm:flex-auto">
                <input
                  type="email"
                  id="email-address"
                  required
                  aria-label="Email address"
                  placeholder="Email address"
                  className="peer relative z-10 w-full appearance-none bg-transparent px-4 py-2 text-base text-black placeholder:text-gray-700 focus:outline-none sm:py-3"
                  
                />
                <div className="absolute inset-0 rounded-md border border-black peer-focus:border-blue-300 peer-focus:bg-gray-100 peer-focus:ring-1 peer-focus:ring-gray-500 sm:rounded-xl" />
              </div>
              <button
                type="submit"
                color="white"
                className="mt-4 w-full bg-[#84C859] text-white p-2 rounded-md sm:relative sm:z-10 sm:mt-0 sm:w-auto sm:flex-none"
                data-aos="fade-up"
              >
                Subscribe
              </button>
            </div>
          </form>
        </Container>
      </div>
    </section>
  );
}
